import { Badge } from '@tribeplatform/react-ui-kit/Badge'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip'

export interface FileTypeWithTooltip {
  type: string
  toolTip: string
}

interface FileTypeBadgeProps {
  fileType: FileTypeWithTooltip
  onClick: () => void
}
export const FileTypeBadge = ({ fileType, onClick }: FileTypeBadgeProps) => {
  return (
    <Tooltip>
      <Tooltip.Trigger>
        <Button variant="tertiaryNeutral" className="p-0" onClick={onClick}>
          <Badge trailingIcon={<SvgIcon name="plus" />} truncate>
            {fileType.type}
          </Badge>
        </Button>
      </Tooltip.Trigger>
      <Tooltip.Panel>{fileType.toolTip}</Tooltip.Panel>
    </Tooltip>
  )
}
